module.exports = __webpack_public_path__ + "img/Filter Button Selected.6fcb27ba.png";